import { useCallback, useRef } from "react";

export const withAbortHandling = async (apiCallPromise, errorMessage = "요청이 취소되었습니다") => {
    try {
        const result = await apiCallPromise;
        return { success: true, data: result };
    } catch (error) {
        if (error.name === "AbortError" || error.code === "ERR_CANCELED") {
            return { canceled: true };
        }
        console.error(error);
        return { success: false, error };
    }
};

const useAbortController = () => {
    const controllersRef = useRef({});

    const getNewController = useCallback((requestType) => {
        if (controllersRef.current[requestType]) {
            controllersRef.current[requestType].abort();
        }
        const controller = new AbortController();
        controllersRef.current[requestType] = controller;

        return controller.signal;
    }, []);

    const abortAll = useCallback(() => {
        Object.values(controllersRef.current).forEach((controller) => {
            controller.abort();
        });
        controllersRef.current = {};
    }, []);

    const abort = useCallback((requestType) => {
        if (controllersRef.current[requestType]) {
            controllersRef.current[requestType].abort();
            delete controllersRef.current[requestType];
        }
    }, []);

    const handleApiResult = useCallback((result, onCancel = null) => {
        if (result && result.canceled) {
            if (onCancel) onCancel();

            const cancelError = new Error("API 요청이 취소되었습니다");
            cancelError.name = "AbortError";
            cancelError.code = "ERR_CANCELED";
            cancelError.canceled = true;

            throw cancelError;
        }

        return result;
    }, []);

    return { getNewController, abortAll, abort, handleApiResult };
};

export default useAbortController;
